import { createPortal } from 'react-dom';
import clsx from 'clsx';

interface ConfirmCloseModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

/** Доп. подтверждение перед закрытием формы создания/редактирования задачи —
 *  сама форма больше не закрывается по клику вне или по Esc напрямую. */
export function ConfirmCloseModal({
  open,
  onCancel,
  onConfirm,
}: ConfirmCloseModalProps) {
  if (!open) {
    return null;
  }

  return createPortal(
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 px-3 animate-in fade-in-0 duration-200"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onCancel();
        }
      }}
    >
      <div
        className={clsx(
          'w-full max-w-[360px] rounded-[18px] bg-white px-[22px] py-[20px]',
          'font-sans shadow-[0_20px_60px_rgba(20,30,49,0.18)]',
          'animate-in fade-in-0 zoom-in-95 duration-200 ease-out'
        )}
        role="alertdialog"
        aria-modal="true"
        aria-label="Подтверждение закрытия"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="text-[13px] font-bold text-[#141E31]">
          Уверены, что желаете закрыть?
        </div>
        <div className="mt-[6px] text-[12px] text-[rgba(20,30,49,0.6)]">
          Все данные будут потеряны.
        </div>

        <div className="mt-[18px] flex justify-end gap-[10px]">
          <button
            type="button"
            onClick={onCancel}
            className="min-w-[76px] rounded-full border border-[rgba(59,77,127,0.16)] px-[16px] py-[9px] text-[12px] font-bold text-[#141E31] transition hover:bg-[rgba(59,77,127,0.06)]"
          >
            Нет
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="min-w-[76px] rounded-full bg-[#EF4642] px-[16px] py-[9px] text-[12px] font-bold text-white transition hover:bg-[#d93f3b]"
          >
            Да
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
